<template>
  <router-link to="contact">
    {{ $t('request_information') }}
  </router-link>
</template>

<script>
export default {
  name: 'follow-up-contact'
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
a {
  transform: rotate(180deg);
  writing-mode: vertical-rl;
  background: $turq;
  padding: 2em .7em 2em .2em;
  z-index: 9000;
  position: fixed;
  top: 30vh;
  right: 0;
  color: white;
  font-size: 1.2em;
  text-transform: uppercase;
  font-family: MuseoSans-700;
  border-top-right-radius: 1em;
  border-bottom-right-radius: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/product/FollowUpContact.vue